import React from 'react'
import MaterialSymbol from '../material-symbol'

const ArrowDownward = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="arrow_downward" {...props} />
))

ArrowDownward.displayName = 'ArrowDownward'

export default ArrowDownward
